import { render, staticRenderFns } from "./TeacherMedia.vue?vue&type=template&id=cf2d2c10&"
import script from "./TeacherMedia.vue?vue&type=script&lang=js&"
export * from "./TeacherMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports